import { VariantProps, cva } from 'class-variance-authority';
import type { CommonProps } from '../../types';
import {
    Heading,
    SwitchController,
    LogoTag,
    getIconComponent,
    getIconName,
} from '../../';
import { twMerge } from 'tailwind-merge';
import type { Genres, VenueId } from '@beat-venues/common-types';
import { ChangeEvent, type JSX } from 'react';

export interface CheckboxSliderProps
    extends CommonProps,
        VariantProps<typeof CheckboxSliderStyles> {
    label: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    genre?: Genres;
    venueId?: VenueId | 'my-beat';
    checked?: boolean;
    disabled?: boolean;
    textColor?: string;
}

export const CheckboxSliderStyles = cva('click-area flex justify-between my-2');
export const CheckboxSlider = ({
    className,
    testId = 'checkbox-slider',
    label,
    venueId,
    genre,
    checked,
    disabled,
    textColor = 'text-white',
    onChange,
}: CheckboxSliderProps): JSX.Element => {
    return (
        <div
            className={twMerge(CheckboxSliderStyles({ className }))}
            data-testid={testId}
        >
            <div className="flex items-center justify-center">
                {genre ? (
                    getIconComponent(getIconName(genre), {
                        size: 'xl',
                    })
                ) : venueId ? (
                    <LogoTag venueId={venueId} className="min-w-12" size="sm" />
                ) : (
                    <div></div>
                )}
                <Heading as="h6" className={`mb-0 pl-4 ${textColor}`}>
                    {label}
                </Heading>
            </div>
            <SwitchController
                name={label.split(' ').join('-')}
                label={label}
                onChange={onChange}
                className="click-area-link"
                disabled={disabled}
                checked={checked}
            />
        </div>
    );
};
